import AudioBlock from './AudioBlock';

export default AudioBlock;